import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetOverstaffedRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetOverstaffedResponseDtoSchema = z.object({
  count: z.number().nullable(),
  changePct: z.number().nullable(),
});

export type GetOverstaffedRequestDto = z.infer<
  typeof _GetOverstaffedRequestDtoSchema
>;
export type GetOverstaffedResponseDto = z.infer<
  typeof GetOverstaffedResponseDtoSchema
>;

export const getOverstaffed = (
  params: GetOverstaffedRequestDto,
  config?: AxiosRequestConfig<GetOverstaffedRequestDto>
) => {
  return api
    .get('/staff/overstaffed', {
      params,
      ...config,
    })
    .then(responseContract(GetOverstaffedResponseDtoSchema));
};
